module.exports = __webpack_public_path__ + "static/assets/37de3069a22757d8aa830b8632980f94.png";